import { Fragment, useEffect, useRef, useState, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useEditor } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import { StepsSection } from '../StepsSection';
import TopMobile from '../TopMobile';
import { ReactComponent as ArrowBack } from './arrow-back.svg';
import { ReactComponent as Home } from './home.svg';
import { ReactComponent as Wave } from '../assets/wave.svg';
import { ReactComponent as Logo } from './logo.svg';
import clsx from 'clsx';
import style from './style.module.scss';

const MenuList = ({ menu, categories, seeMore, isHome, homeUrl }) => {
    const { isEditing } = useEditor();
    const isMobile = useMediaQuery({
        query: '(max-width: ' + style.tabletBreakpoint + ')',
    });

    const [menuOpen, setMenuOpen] = useState(false);
    const [adminSteps, setAdminSteps] = useState([]);
    const [waveLeft, setWaveLeft] = useState(0);
    const [currentSubmenu, setCurrentSubmenu] = useState(null);
    const [currentSubmenu2, setCurrentSubmenu2] = useState(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

    const menuRef = useRef(null);
    const menuItemRef = useRef([]);

    const halfIndex = Math.ceil(menu?.length / 2);

    const moveWave = useCallback(
        (i) => {
            if (isMobile) {
                return;
            }

            const timeout = setTimeout(
                () =>
                    setWaveLeft(
                        menuItemRef.current[i]?.offsetLeft +
                            menuItemRef.current[i]?.clientWidth / 2 -
                            menuRef.current?.offsetLeft,
                    ),
                250,
            );

            return timeout;
        },
        [isMobile],
    );

    useEffect(() => {
        if (!isEditing) return;

        const ac = new AbortController();

        apiFetch({ path: 'categories-steps/v1/get', signal: ac.signal })
            .then((res) => {
                setAdminSteps(res);
            })
            .catch((e) => {
                if (!(e instanceof DOMException) || e.code !== e.ABORT_ERR) {
                    console.error(e);
                }
            });

        return () => ac.abort();
    }, [isEditing]);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : 'initial';

        if (!menuOpen) {
            setCurrentSubmenu(null);
            setCurrentSubmenu2(null);
        }

        return () => null;
    }, [menuOpen]);

    useEffect(() => {
        const timeout = moveWave(0);

        return () => clearTimeout(timeout);
    }, [menuItemRef, moveWave]);

    const goBackMenu = () => {
        if (currentSubmenu2) {
            setCurrentSubmenu2(null);
        } else {
            setCurrentSubmenu(null);
        }
    };

    const goSubmenu = (e, menu) => {
        if (!isMobile || !menu.children?.length) {
            return;
        }

        e.preventDefault();
        setCurrentSubmenu(menu);
    };

    const goSubmenu2 = (e, menu) => {
        if (!isMobile || !menu.children?.length) {
            return;
        }

        e.preventDefault();
        setCurrentSubmenu2(menu);
    };

    // const handleScroll = () => {
    //     setIsSubMenuOpen(false);
    //     window.removeEventListener('scroll', handleScroll);
    // };

    const openSubMenu = (menuItem, i) => {
        moveWave(i);
        if (menuItem?.children.length > 0 || menuItem.post_name === 'mes-demarches') {
            setIsSubMenuOpen(true);
            // window.addEventListener('scroll', handleScroll);
        }
    };

    const closeSubMenu = () => {
        moveWave(0);
        setIsSubMenuOpen(false);
    };

    const levelClass = currentSubmenu2 ? 'level2' : currentSubmenu ? 'level1' : '';

    const Submenu = ({ submenu, current }) => {
        if (isMobile && current) {
            return (
                <div className={style.subMenuMobileContainer}>
                    <p className={style.goBack} onClick={goBackMenu}>
                        <ArrowBack className={style.arrow} />
                        Retour
                    </p>
                    <p className={style.menuItemSubTitle}>{submenu.title}</p>
                    <ul className={style.menuItemChildren}>
                        {submenu.children.map((subItem, _) => (
                            <li key={subItem.ID}>
                                <a href={subItem.url || undefined} onClick={(e) => goSubmenu2(e, subItem)}>
                                    {subItem.title || subItem.name}
                                </a>
                                {subItem.post_content && <p>{subItem.post_content}</p>}

                                {subItem?.children.length > 0 && (
                                    <Submenu2 submenu={subItem} current={currentSubmenu2 === subItem} />
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }

        return (
            <div className={style.subMenuContainer}>
                <ul className={style.menuItemChildren}>
                    {submenu.children.map((subItem, _) => (
                        <li key={subItem.ID}>
                            <a href={subItem.url || undefined}>{subItem.title}</a>
                            {subItem.children.length > 0 && (
                                <ul className={style.menuSubItemChildren}>
                                    {subItem.children.map((subSubItem, _) => (
                                        <li
                                            key={
                                                subSubItem && subSubItem.ID
                                                    ? subItem.ID + '_' + subSubItem.ID
                                                    : subItem.ID
                                            }
                                        >
                                            <a href={subSubItem.url || undefined}>{subSubItem.title}</a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    const Submenu2 = ({ submenu, current }) => {
        const isMobile = useMediaQuery({
            query: '(max-width: ' + style.tabletBreakpoint + ')',
        });

        if (isMobile) {
            return (
                current && (
                    <div className={style.subMenuMobileContainer}>
                        <p className={style.goBack} onClick={goBackMenu}>
                            <ArrowBack className={style.arrow} />
                            Retour
                        </p>
                        <p className={style.menuItemSubTitle}>{submenu.title}</p>
                        <ul className={style.menuItemChildren}>
                            {submenu.children.map((subItem, _) => (
                                <li key={subItem.ID}>
                                    <a href={subItem.url || undefined}>{subItem.title || subItem.name}</a>
                                    {subItem.post_content && <p>{subItem.post_content}</p>}
                                    {subItem?.children.length > 0 && (
                                        <ul>
                                            {subItem.children.map((subsubItem, _) => (
                                                <li key={subsubItem.ID}>
                                                    <a href={subsubItem.url || undefined}>
                                                        {subsubItem.title || subsubItem.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                )
            );
        }

        return (
            <div className={style.subMenuContainer}>
                <ul className={style.menuItemChildren}>
                    {submenu.children.map((subItem, _) => (
                        <li key={subItem.ID}>
                            <a href={subItem.url || undefined}>{subItem.title}</a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    return (
        <>
            {isMobile && (
                <TopMobile
                    toggleMenu={() => setMenuOpen(!menuOpen)}
                    menuOpen={menuOpen}
                    dark={currentSubmenu || currentSubmenu2}
                    isHome={isHome}
                    homeUrl={homeUrl}
                    levelClass={levelClass}
                />
            )}
            <div
                className={clsx(
                    style.menu,
                    menuOpen && style.open,
                    style[levelClass],
                    isHome && style.home,
                    isSubMenuOpen && style.subMenuOpened,
                )}
            >
                <ul className={clsx(style.menuList, levelClass && style.sub)} ref={menuRef}>
                    {!isEditing &&
                        menu.map((menuItem, i) => (
                            <Fragment key={'menu_item_' + i}>
                                {i === halfIndex && (
                                    <li className={style.menuLogo}>
                                        <a href="/">
                                            <Logo className={style.logo} />
                                        </a>
                                    </li>
                                )}
                                <li
                                    className={style.menuItem}
                                    onMouseEnter={() => openSubMenu(menuItem, i)}
                                    onMouseLeave={() => closeSubMenu()}
                                >
                                    <div className={style.menuItemTitle}>
                                        <a
                                            ref={(el) => (menuItemRef.current[i] = el)}
                                            href={menuItem.url || undefined}
                                            className={clsx(style.menuItemUrl, i === 0 && style.home)}
                                            onClick={(e) => goSubmenu(e, menuItem)}
                                        >
                                            {menuItem.title}
                                            {i === 0 && <Home className={style.homeIcon} />}
                                        </a>
                                    </div>

                                    {((!isMobile &&
                                        menuItem.post_name !== 'mes-demarches' &&
                                        menuItem?.children.length > 0) ||
                                        (isMobile && menuItem?.children.length > 0)) && (
                                        <>
                                            {!isMobile ? (
                                                <div className={style.subMenuContainer}>
                                                    <Submenu
                                                        submenu={menuItem}
                                                        goBack={goBackMenu}
                                                        current={currentSubmenu === menuItem}
                                                    />
                                                </div>
                                            ) : (
                                                <Submenu
                                                    submenu={menuItem}
                                                    goBack={goBackMenu}
                                                    current={currentSubmenu === menuItem}
                                                />
                                            )}
                                        </>
                                    )}

                                    {!isMobile && menuItem.post_name === 'mes-demarches' && (
                                        <div className={style.subMenuContainer}>
                                            <StepsSection categories={categories} seeMore={seeMore} />
                                        </div>
                                    )}
                                </li>
                            </Fragment>
                        ))}

                    {menu?.length % 2 !== 0 && <li className={clsx(style.menuItem, style.dummy)}></li>}

                    {isEditing && <StepsSection categories={adminSteps} />}
                </ul>

                <div className={style.waveContainer}>
                    <Wave className={style.wave} style={{ left: waveLeft }} />
                </div>
            </div>
        </>
    );
};

export default MenuList;
